import React, { useState, useEffect } from 'react';
import CoupanServices from '../../services/CoupanServices.js';

function UpdateCoupan({ data, closeModal, onSuccess }) {

  const [formValues, setFormValues] = useState({
    name: '',
    upto: '',
    numberOfCoupons: '',
    endDate: '',
    price: '',
    maxDiscountAmount: '',
    sequence: '',
    actualPrice: "",
    discountPrice: "",
    termsAndConditions: '',
    totalnumberOfusagesCoupons: '',
    totalnumberOfusagesperuserCoupons: '',
    categoryId: '',
    serviceId: '',
    vendorId: '',
    image: ""
  });

  const [categories, setCategories] = useState([]);
  const [vendors, setVendors] = useState([]);
  const [services, setServices] = useState([]);
  const [loading, setLoading] = useState(false);
  const [initialLoading, setInitialLoading] = useState(true);
  const [servicesLoading, setServicesLoading] = useState(false);
  const [imagePreview, setImagePreview] = useState(null);
  // Fetch categories and vendors on component mount
  useEffect(() => {
    const fetchInitialData = async () => {
      setInitialLoading(true);
      try {
        // Fetch categories
        const categoriesRes = await CoupanServices.getMembershipCategories();
        if (categoriesRes.status && categoriesRes.data) {
          setCategories(Array.isArray(categoriesRes.data) ? categoriesRes.data : []);
        }
        const vendorsRes = await CoupanServices.getActiveVendors();
        if (vendorsRes.status && vendorsRes.data) {
          setVendors(Array.isArray(vendorsRes.data) ? vendorsRes.data : []);
        }
      } catch (error) {
        console.error('Error fetching initial data:', error);
        setCategories([]);
        setVendors([]);
      } finally {
        setInitialLoading(false);
      }
    };

    fetchInitialData();
  }, []);
  const fetchServicesByVendor = async (vendorId) => {
    if (!vendorId) {
      setServices([]);
      return [];
    }
    setServicesLoading(true);
    try {
      const response = await CoupanServices.getVendorByServices(vendorId);
      if (response.status && response.data) {
        const servicesData = Array.isArray(response.data) ? response.data : [];
        setServices(servicesData);
        return servicesData;
      } else {
        setServices([]);
        return [];
      }
    } catch (error) {
      console.error('Error fetching services:', error);
      setServices([]);
      return [];
    } finally {
      setServicesLoading(false);
    }
  };

  const extractId = (field) => {
    if (!field) return '';
    if (typeof field === 'string') return field;
    if (field._id) return String(field._id);
    if (field.id) return String(field.id);
    if (typeof field.toString === 'function' && field.toString() !== '[object Object]') {
      return field.toString();
    }
    return '';
  };

  useEffect(() => {
    const loadCouponData = async () => {
      if (data && !initialLoading) {
        if (data?.image) {
          setImagePreview(`${process.env.REACT_APP_URL}${data.image}`);
        }
        const formattedEndDate = data?.endDate
          ? new Date(data.endDate).toISOString().split('T')[0]
          : '';
        let categoryId = '';
        if (data.categoryId) {
          categoryId = extractId(data.categoryId);
        } else if (data.category) {
          categoryId = extractId(data.category);
        }

        let vendorId = '';
        if (data.vendorId) {
          vendorId = extractId(data.vendorId);
        } else if (data.vendor) {
          vendorId = extractId(data.vendor);
        }

        // Service ID
        let serviceId = '';
        if (data.serviceId) {
          serviceId = extractId(data.serviceId);
        } else if (data.service) {
          serviceId = extractId(data.service);
        }

        console.log('Extracted IDs:', {
          categoryId: categoryId || 'EMPTY',
          vendorId: vendorId || 'EMPTY',
          serviceId: serviceId || 'EMPTY'
        });
        // Set form values
        setFormValues({
          name: data?.name || '',
          upto: data?.upto || '',
          sequence: data?.sequence || '',
          numberOfCoupons: data?.numberOfCoupons || '',
          endDate: formattedEndDate,
          price: data?.price || '',
          maxDiscountAmount: data?.maxDiscountAmount || '',
          actualPrice: data?.actualPrice ?? '',
          discountPrice: data?.discountPrice ?? '',
          termsAndConditions: data?.termsAndConditions || '',
          totalnumberOfusagesCoupons: data?.totalnumberOfusagesCoupons || '',
          totalnumberOfusagesperuserCoupons: data?.totalnumberOfusagesperuserCoupons || '',
          categoryId: categoryId,
          vendorId: vendorId,
          serviceId: ''
        });

        // If vendor exists, load services
        if (vendorId) {
          console.log('Loading services for vendor ID:', vendorId);
          const servicesData = await fetchServicesByVendor(vendorId);

          // After services are loaded, set the service ID
          if (servicesData && servicesData.length > 0 && serviceId) {
            const serviceExists = servicesData.find(
              (s) => String(s._id) === serviceId
            );

            if (serviceExists) {
              console.log('Setting service ID:', serviceId);
              setFormValues(prev => ({
                ...prev,
                serviceId: serviceId
              }));
            } else {
              console.log('Service ID not found in loaded services:', serviceId);
              console.log('Available services:', servicesData.map(s => ({ id: s._id, title: s.title })));
            }
          } else if (serviceId && servicesData.length === 0) {
            console.log('No services found for vendor, but service ID exists:', serviceId);
          }
        }
      }
    };

    loadCouponData();
  }, [data, initialLoading]);

  const handleInputChange = (event) => {
    const { name, value } = event.target;

    console.log('Input changed:', name, value);

    if (name === 'categoryId') {
      setFormValues({
        ...formValues,
        categoryId: value,
        vendorId: '',
        serviceId: ''
      });
      setServices([]);
    } else if (name === 'vendorId') {
      setFormValues({
        ...formValues,
        vendorId: value,
        serviceId: ''
      });
      setServices([]);
      if (value) {
        fetchServicesByVendor(value);
      }
    } else {
      setFormValues({
        ...formValues,
        [name]: value,
      });
    }
  };

  const validateForm = () => {
    const { endDate, categoryId, serviceId, vendorId, name, price } = formValues;
    const currentDate = new Date();
    const selectedEndDate = new Date(endDate);

    if (!endDate) {
      alert('Please select an end date.');
      return false;
    }

    if (selectedEndDate < currentDate.setHours(0, 0, 0, 0)) {
      alert('End Date cannot be earlier than today.');
      return false;
    }

    if (!categoryId) {
      alert('Please select a category.');
      return false;
    }

    if (!vendorId) {
      alert('Please select a vendor.');
      return false;
    }

    if (!serviceId) {
      alert('Please select a service.');
      return false;
    }

    if (!name.trim()) {
      alert('Please enter coupon code name.');
      return false;
    }
    // if (!price || price <= 0) {
    //   alert('Please enter minimum services amount.');
    //   return false;
    // }
    return true;
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    if (!validateForm()) return;

    setLoading(true);

    try {
      // const submitData = {
      //   categoryId: formValues.categoryId,
      //   serviceId: formValues.serviceId,
      //   vendorId: formValues.vendorId,
      //   name: formValues.name.trim(),
      //   upto: formValues.upto ? Number(formValues.upto) : 0,
      //   numberOfCoupons: formValues.numberOfCoupons ? Number(formValues.numberOfCoupons) : 0,
      //   totalnumberOfusagesCoupons: formValues.totalnumberOfusagesCoupons ? Number(formValues.totalnumberOfusagesCoupons) : 0,
      //   totalnumberOfusagesperuserCoupons: formValues.totalnumberOfusagesperuserCoupons ? Number(formValues.totalnumberOfusagesperuserCoupons) : 0,
      //   coupanCounter: data?.coupanCounter || 0,
      //   endDate: formValues.endDate,
      //   price: formValues.price ? Number(formValues.price) : 0,
      //   maxDiscountAmount: formValues.maxDiscountAmount ? Number(formValues.maxDiscountAmount) : 0,
      //   termsAndConditions: formValues.termsAndConditions || '',
      //   status: "Active"
      // };

      const formData = new FormData();
      formData.append("categoryId", formValues.categoryId);
      formData.append("serviceId", formValues.serviceId);
      formData.append("vendorId", formValues.vendorId);
      formData.append("name", formValues.name.trim());
      formData.append("endDate", formValues.endDate);
      formData.append("termsAndConditions", formValues.termsAndConditions);
      formData.append("upto", Number(formValues.upto) || 0);
      formData.append("sequence", Number(formValues.sequence) || 0);
      formData.append("discountPrice", Number(formValues.discountPrice) || 0);
      formData.append("actualPrice", Number(formValues.actualPrice) || 0);
      formData.append("price", Number(formValues.price) || 0);
      formData.append("maxDiscountAmount", Number(formValues.maxDiscountAmount) || 0);
      formData.append("numberOfCoupons", Number(formValues.numberOfCoupons) || 0);
      formData.append("totalnumberOfusagesCoupons", Number(formValues.totalnumberOfusagesCoupons) || 0);
      formData.append("totalnumberOfusagesperuserCoupons", Number(formValues.totalnumberOfusagesperuserCoupons) || 0);
      formData.append("status", "Active");

      if (formValues.image instanceof File) {
        formData.append("image", formValues.image);
      }
      console.log('Submitting update data:', formData);

      // await CoupanServices.updateCoupon(data._id || data.id, submitData);
      await CoupanServices.updateCoupon(data._id || data.id, formData);

      alert('Coupon updated successfully');
      onSuccess();
      closeModal();
    } catch (error) {
      console.error('Failed to update coupon', error);
      alert(error.response?.data?.message || 'Failed to update coupon');
    } finally {
      setLoading(false);
    }
  };

  // Debug: Log current form values
  useEffect(() => {
    if (!initialLoading) {
      console.log('Current form values:', {
        categoryId: formValues.categoryId,
        vendorId: formValues.vendorId,
        serviceId: formValues.serviceId,
        name: formValues.name,
        price: formValues.price,
        actualPrice: formValues.actualPrice,
        discountPrice: formValues.discountPrice
      });
    }
  }, [formValues, initialLoading]);

  if (initialLoading) {
    return (
      <div className="modal fade edit-box show d-block" id="editModal" tabIndex={-1}>
        <div className="modal-dialog modal-dialog-centered modal-lg">
          <div className="modal-content">
            <div className="modal-body text-center p-5">
              <div className="spinner-border text-primary" role="status">
                <span className="visually-hidden">Loading...</span>
              </div>
              <p className="mt-3">Loading data...</p>
            </div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="modal fade edit-box show d-block" id="editModal" tabIndex={-1} aria-labelledby="exampleModalLabel" aria-hidden="true">
      <div className="modal-dialog modal-dialog-centered modal-lg">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title">Edit Coupon</h5>
            <button type="button" className="btn-close" data-bs-dismiss="modal" onClick={closeModal} aria-label="Close" />
          </div>
          <div className="modal-body">
            <div className="container-box px-5">
              <div className="container-box-inner table-reponsive-tabe">
                <div className="page-details">
                  <form onSubmit={handleSubmit}>
                    <div className="row">
                      {/* Category Dropdown */}
                      <div className="col-lg-6 col-sm-12">
                        <div className="input-field">
                          <label>Category<span className="red">*</span></label>
                          <select
                            name="categoryId"
                            className="form-control"
                            value={formValues.categoryId}
                            onChange={handleInputChange}
                          >
                            <option value="">Select Category</option>
                            {categories && categories.length > 0 ? (
                              categories.map((category) => (
                                <option key={category._id} value={String(category._id)}>
                                  {category.name}
                                </option>
                              ))
                            ) : (
                              <option disabled>No categories available</option>
                            )}
                          </select>
                        </div>
                      </div>

                      {/* Vendor Dropdown */}
                      <div className="col-lg-6 col-sm-12">
                        <div className="input-field">
                          <label>Vendor<span className="red">*</span></label>
                          <select
                            name="vendorId"
                            className="form-control"
                            value={formValues.vendorId}
                            onChange={handleInputChange}
                          >
                            <option value="">Select Vendor</option>
                            {vendors && vendors.length > 0 ? (
                              vendors.map((vendor) => (
                                <option key={vendor._id} value={String(vendor._id)}>
                                  {vendor.name || vendor.businessName}
                                </option>
                              ))
                            ) : (
                              <option disabled>No vendors available</option>
                            )}
                          </select>
                        </div>
                      </div>

                      {/* Service Dropdown */}
                      <div className="col-lg-6 col-sm-12">
                        <div className="input-field">
                          <label>Service<span className="red">*</span></label>
                          <select
                            name="serviceId"
                            className="form-control"
                            value={formValues.serviceId}
                            onChange={handleInputChange}
                            disabled={!formValues.vendorId || servicesLoading}
                          >
                            <option value="">Select Service</option>
                            {servicesLoading ? (
                              <option disabled>Loading services...</option>
                            ) : (
                              services && services.length > 0 ? (
                                services.map((service) => (
                                  <option key={service._id} value={String(service._id)}>
                                    {service.title}
                                  </option>
                                ))
                              ) : (
                                <option disabled>No services available</option>
                              )
                            )}
                          </select>
                          {!formValues.vendorId && (
                            <small className="text-danger d-block">Please select vendor first</small>
                          )}
                        </div>
                      </div>

                      {/* Coupon Code Name */}
                      <div className="col-lg-6 col-sm-12">
                        <div className="input-field">
                          <label>Coupon Code Name<span className="red">*</span></label>
                          <input
                            type="text"
                            name="name"
                            className="form-control"
                            value={formValues.name}
                            onChange={handleInputChange}
                            placeholder="Enter coupon code name (e.g., WELCOME50)"
                          />
                        </div>
                      </div>

                      <div className="col-lg-6 col-sm-12">
                        <div className="input-field">
                          <label>Image</label>

                          <input
                            type="file"
                            className="form-control"
                            accept="image/*"
                            onChange={(e) => {
                              const file = e.target.files[0];

                              if (file) {
                                setFormValues(prev => ({
                                  ...prev,
                                  image: file
                                }));
                                setImagePreview(URL.createObjectURL(file));
                              }
                            }}
                          />

                          {imagePreview && (
                            <img
                              src={imagePreview}
                              alt="preview"
                              style={{ width: "100px", marginTop: "10px", borderRadius: "6px" }}
                            />
                          )}
                        </div>
                      </div>

                      <div className="col-lg-6 col-sm-6">
                        <div className="input-field">
                          <label>Discount Value (%)</label>
                          <input
                            type="number"
                            name="upto"
                            className="form-control"
                            value={formValues.upto}
                            onChange={handleInputChange}
                            placeholder="5%"
                            min="0"
                            max="100"
                          />
                        </div>
                      </div>

                      <div className="col-lg-6 col-sm-6">
                        <div className="input-field">
                          <label>Sequence</label>
                          <input
                            type="number"
                            name="sequence"
                            className="form-control"
                            value={formValues.sequence}
                            onChange={handleInputChange}
                            placeholder=""
                            min="0"
                          />
                        </div>
                      </div>
                      <div className="col-lg-6 col-sm-6">
                        <div className="input-field">
                          <label>Actual Price</label>
                          <input
                            type="number"
                            name="actualPrice"
                            className="form-control"
                            value={formValues.actualPrice}
                            onChange={handleInputChange}
                            placeholder=""
                            min="0"
                          />
                        </div>
                      </div>
                      <div className="col-lg-6 col-sm-6">
                        <div className="input-field">
                          <label>Discount Price</label>
                          <input
                            type="number"
                            name="discountPrice"
                            className="form-control"
                            value={formValues.discountPrice}
                            onChange={handleInputChange}
                            placeholder=""
                            min="0"
                          />
                        </div>
                      </div>
                      <div className="col-lg-6 col-sm-6">
                        <div className="input-field">
                          <label>Number of Coupons</label>
                          <input
                            type="number"
                            name="numberOfCoupons"
                            className="form-control"
                            value={formValues.numberOfCoupons}
                            onChange={handleInputChange}
                            placeholder="100"
                            min="0"
                          />
                        </div>
                      </div>

                      <div className="col-lg-6 col-sm-6">
                        <div className="input-field">
                          <label>Minimum Services Amount <span className="red">*</span></label>
                          <input
                            type="number"
                            name="price"
                            className="form-control"
                            value={formValues.price}
                            onChange={handleInputChange}
                            placeholder="₹ 1500"
                            min="0"
                            step="1"
                          />
                        </div>
                      </div>

                      <div className="col-lg-6 col-sm-6">
                        <div className="input-field">
                          <label>MAX Discount Amount</label>
                          <input
                            type="number"
                            name="maxDiscountAmount"
                            className="form-control"
                            value={formValues.maxDiscountAmount}
                            onChange={handleInputChange}
                            placeholder="300"
                            min="0"
                          />
                        </div>
                      </div>

                      <div className="col-lg-6 col-sm-6">
                        <div className="input-field">
                          <label>Expire Date<span className="red">*</span></label>
                          <input
                            type="date"
                            name="endDate"
                            className="form-control"
                            value={formValues.endDate}
                            onChange={handleInputChange}
                            min={new Date().toISOString().split('T')[0]}
                          />
                        </div>
                      </div>

                      <div className="col-lg-6 col-sm-6">
                        <div className="input-field">
                          <label>Total Number of Usage Limit</label>
                          <input
                            type="number"
                            name="totalnumberOfusagesCoupons"
                            className="form-control"
                            value={formValues.totalnumberOfusagesCoupons}
                            onChange={handleInputChange}
                            placeholder="10"
                            min="0"
                          />
                        </div>
                      </div>

                      <div className="col-lg-6 col-sm-6">
                        <div className="input-field">
                          <label>Total Number of usage per user</label>
                          <input
                            type="number"
                            name="totalnumberOfusagesperuserCoupons"
                            className="form-control"
                            value={formValues.totalnumberOfusagesperuserCoupons}
                            onChange={handleInputChange}
                            placeholder="2"
                            min="0"
                          />
                        </div>
                      </div>

                      <div className="col-lg-12 col-sm-12">
                        <div className="input-field">
                          <label>Terms And Conditions</label>
                          <textarea
                            className="form-control video-desc h-auto"
                            name="termsAndConditions"
                            value={formValues.termsAndConditions}
                            onChange={handleInputChange}
                            placeholder="Enter Terms And Conditions"
                            rows="4"
                          />
                        </div>
                      </div>
                    </div>

                    <div className="text-center mt-4">
                      <button
                        className="submit-green-btn"
                        type="submit"
                        disabled={loading}
                        style={{ minWidth: '150px' }}
                      >
                        {loading ? 'UPDATING...' : 'UPDATE'}
                      </button>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default UpdateCoupan;